<template>
  <div
    :class="`tw:sticky! tw:top-0 tw:z-50 tw:flex tw:w-full tw:h-14 tw:items-center tw:text-usdg-color-text-title ${customClass}`"
  >
    <button
      v-if="$slots.left"
      type="button"
      aria-label="left"
      class="tw:px-3 tw:absolute! tw:left-4 tw:inline-flex tw:h-10 tw:items-center tw:justify-center tw:cursor-pointer"
      @click="emits('left-click')"
    >
      <slot name="left" />
    </button>

    <div class="tw:absolute! tw:left-1/2 tw:-translate-x-1/2 tw:typo-title-xs tw:font-semibold">
      <slot name="title" />
    </div>

    <button
      v-if="$slots.right"
      id="gtm_share_btn"
      type="button"
      aria-label="right"
      class="tw:absolute! tw:right-4 tw:inline-flex tw:h-10 tw:items-center tw:justify-center tw:cursor-pointer"
      @click="emits('right-click')"
    >
      <slot name="right" />
    </button>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    customClass?: string
  }>(),
  {
    customClass: 'tw:bg-white'
  }
)

const emits = defineEmits<{
  'left-click': []
  'right-click': []
}>()
</script>
